export default "__VITE_ASSET__BcyCzeSh__"